const affiliateChapterEventsApp = Vue.createApp({
    data() {
        return {
            events: affiliateChapterEvents,
            eventsSuperset: affiliateChapterEvents,
            
            eventPage: 1,
            eventPerPage: pageSize,
            eventPages: [],
            totalNumberofEventPages: 0,
            
            selectedCountry: "",
            selectedState: "",
            selectedAffiliateChapter: "",

            countryDataset: typeof countryDataset !== 'undefined' ? countryDataset : [],
            stateDataset: typeof stateDataset !== 'undefined' ? stateDataset : {},

            countrySuperset: [],
            affiliateChapterSuperset: []
        }
    },
    
    methods: {

        buildCountrySuperset() {
            const eventCountryCodes = [...new Set(affiliateChapterEvents
                .map(e => e.CountryCode)
                .filter(c => c != null && c !== "" && c !== undefined)
            )];
            return this.countryDataset
                .filter(country => eventCountryCodes.includes(country.id))
                .sort((a, b) => a.text.localeCompare(b.text));
        },
        
        buildAffiliateChapterSuperset() {
            return [...new Set(affiliateChapterEvents
                .map(e => e.Title)
                .filter(t => t != null && t !== "" && t !== undefined)
            )].sort((a, b) => a.localeCompare(b));
        },

        setEventPages(events) {
            this.eventPages = [];
            this.totalNumberofEventPages = Math.ceil(events.length / this.eventPerPage);
            this.eventPages = pagination(this.eventPage, this.totalNumberofEventPages);
        },
        
        paginate(items, page, perPage) {
            let from = (page * perPage) - perPage;
            let to = (page * perPage);
            return items.slice(from, to);
        },
        
        resetPages() {
            this.eventPage = 1;
        },
        
        resetAllFilters() {
            this.selectedCountry = "";
            this.selectedState = "";
            this.selectedAffiliateChapter = "";
        },
        
        getRegionCountryName(event) {
            if (!event) return '';
            let countryName = '';
            let stateName = '';
            
            if (event.CountryCode && this.countryDataset && Array.isArray(this.countryDataset)) {
                const country = this.countryDataset.find(c => c.id === event.CountryCode);
                if (country) countryName = country.text;
            }
            
            if (event.StateCode && event.CountryCode && this.stateDataset && this.stateDataset[event.CountryCode]) {
                const state = this.stateDataset[event.CountryCode].find(s => s.id === event.StateCode);
                if (state) stateName = state.text;
            }
            if (stateName && countryName) return `${stateName}, ${countryName}`;
            if (countryName) return countryName;
            return '';
        },

        getMediaUrlFromPath(path, storageType) {
            if (typeof window.getMediaUrlFromPath === 'function') {
                return window.getMediaUrlFromPath(path, storageType);
            }
            return path || '';
        }
    },
    
    computed: {
        filteredStateSuperset() {
            if (!this.selectedCountry || !this.stateDataset[this.selectedCountry]) return [];
            
            const eventStateCodes = [...new Set(this.eventsSuperset
                .filter(e => e.CountryCode === this.selectedCountry)
                .map(e => e.StateCode)
                .filter(s => s != null && s !== "" && s !== undefined)
            )];
            return this.stateDataset[this.selectedCountry]
                .filter(state => eventStateCodes.includes(state.id))
                .sort((a, b) => a.text.localeCompare(b.text));
        },

        displayedEvents() {
            let filteredEvents = this.eventsSuperset;
            if (this.selectedCountry != "") {
                filteredEvents = filteredEvents.filter(e => e.CountryCode == this.selectedCountry);
            }
            
            if (this.selectedState != "") {
                filteredEvents = filteredEvents.filter(e => e.StateCode == this.selectedState);
            }
            
            if (this.selectedAffiliateChapter != "") {
                filteredEvents = filteredEvents.filter(e => e.Title === this.selectedAffiliateChapter);
            }
            
            filteredEvents = filteredEvents.sort((a, b) => {
                return (a.EventStartDateTime || '').localeCompare(b.EventStartDateTime || '');
            });
            
            this.setEventPages(filteredEvents);
            this.events = filteredEvents;
            
            return this.paginate(filteredEvents, this.eventPage, this.eventPerPage);
        },
        
        filteredEventsCount() {
            return this.events.length;
        }
    },
    
    watch: {
        selectedCountry: function() { 
            this.selectedState = "";
            this.resetPages();
            scrollOnPagination("events-listing-section");
        },
        selectedState: function() { 
            this.resetPages();
            scrollOnPagination("events-listing-section");
        },
        selectedAffiliateChapter: function() {
            this.resetPages();
            scrollOnPagination("events-listing-section");
        },
        eventPage: function() { 
            scrollOnPagination("events-listing-section");
        }
    },
    
    created() {
        this.countrySuperset = this.buildCountrySuperset();
        this.affiliateChapterSuperset = this.buildAffiliateChapterSuperset();
    },
    
    mounted() {
    }
});

const affiliateChapterEventsMountedApp = affiliateChapterEventsApp.mount('#affiliateChapterEvents');
